import type { SessionConfig } from '../types';
import { getSessionId } from './session';

export function messageAnalyticsContext(sessionConfig?: SessionConfig) {
  return {
    sessionId: getSessionId(sessionConfig) || undefined,
    pageUrl: typeof window !== 'undefined' ? window.location.href : undefined,
    referrer: typeof document !== 'undefined' ? document.referrer : undefined,
  };
}
